<template>
  <div class="msg_list">
    <div class="top orangeToYellow">
      <span>我的消息</span>
    </div>
    <div class="body">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        class="list"
        @load="onLoad"
        :immediate-check="true"
      >
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="ctn">
            {{ item.content }}
          </div>
          <div class="time">
            <span>警报时间：</span>
            <span>{{ item.alertTime }}</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      pages: 0,
      total: 0,
      loading: false,
      finished: false,
      isFirst: true
    };
  },

  mounted() {
    this.page = 1;
    this.pageSize = 10;
    this.onLoad();
  },

  methods: {
    async onLoad() {
      this.loading = true;
      if (this.isFirst) {
        await this.getList();
      } else {
        this.page <= this.pages && (await this.getList());
      }
      this.loading = false;
      if (this.page > this.pages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    },

    // 获取数据
    async getList() {
      try {
        await this.$toast.loading({
          message: this.$t("common.loading"),
          forbidClick: true,
          duration: 0
        });

        this.isFirst = false;
        await this.$api
          .getMessageList({
            page: this.page,
            pageSize: this.pageSize
          })
          .then(res => {
            if (res.errcode === 0 && res.list && res.list.length) {
              let list = res.list;
              let oldList = [...this.list, ...list];
              this.list.push(...list);
              this.pages = res.pages;
              this.page++;
            } else {
            }
          })
          .finally(() => {
            this.$toast.clear();
          });
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  color: #ffffff;
  font-size: 16px;
  line-height: 60px;
  padding: 0 10px;
}

.body {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: calc(100% - 90px);
  justify-content: space-between;
  text-align: left;
  box-sizing: border-box;
}
.list {
  margin: 10px;
}

.item {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #c9c9c9c9;
  border-radius: 8px;

  .title {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #c9c9c9c9;
    margin-left: -10px;
    margin-right: -10px;
    padding: 0 10px 6px;
  }

  .ctn {
    font-size: 14px;
    padding: 10px;
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #c9c9c9c9;
  }

  .time {
    font-size: 12px;
    text-align: right;
  }
}
</style>
